import { formatMoney } from '../../lib';
import type { ContextCartItem } from '../types';

export function useCartItem(item: ContextCartItem) {
  const formattedPrice = formatMoney(item.price);
  const formattedOriginalPrice = formatMoney(item.originalPrice);
  const isBackorder = item.allowBackorder && !!item.preOrderTag;
  const preOrderTag = item.preOrderTag?.split(':')[1];

  const hasDiscount =
    Number.parseFloat(item.originalPrice.amount).toFixed(2) !==
    Number.parseFloat(item.price.amount).toFixed(2);

  return {
    price: formattedPrice,
    originalPrice: formattedOriginalPrice,
    hasDiscount,
    preOrder: {
      isPreOrder: isBackorder,
      text: `Pre-order: FOR ${preOrderTag}`,
    },
  };
}
